import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { AddSuppliersNew } from '../../Onboarding/add-suppliers-new';

import clsx from 'clsx';
import SvgCarIcon from '../../../../assets/images/svg-components/CarIcon';
import SvgShopIcon from '../../../../assets/images/svg-components/ShopIcon';
import { CommonButton } from '../../../../shared/components/common-button';
import { LocalStorageService } from '../../../../shared/services/localStorage.service';
import { useStyles } from './style';
import { SupplierType } from '../../../../shared/constants/supplierType';

export const AddSupplierTab: React.FC = () => {
  const classes = useStyles();
  const { state: navState, pathname } = useLocation<{ addForm: boolean } | null>();
  const [selectedSupplierType, setSelectedSupplierType] = useState<SupplierType>();
  const { replace, push } = useHistory();

  useEffect(() => {
    LocalStorageService.clear('manual_supplier_id');
    LocalStorageService.clear('manualSupplierName');
  }, []);

  return navState?.addForm && selectedSupplierType ? (
    <div className={classes.root}>
      <div className={classes.title}>Lets add your suppliers</div>
      <div className={classes.subtitle}>Please search and select your suppliers to proceed with the next step</div>
      <AddSuppliersNew
        category={null}
        categories={[]}
        onboarded={true}
        selectedSupplierType={selectedSupplierType}
        resetForm={() => {
          setSelectedSupplierType(undefined);
          replace({
            pathname: pathname,
            state: {
              ...(navState || {}),
              addForm: false,
            },
          });
        }}
        openNextCategory={() => {
          push('/account/suppliers');
        }}
        setManualSupplier={() => {
          push('/account/onboard-manual-supplier');
        }}
      />
    </div>
  ) : (
    <div className={clsx(classes.root, classes.typeScreen)}>
      <div className={clsx(classes.title, classes.supplierPageTitle)}>Two ways to manage your products & prices:</div>
      <div className={classes.supplierTypeWrap}>
        <div className={classes.recWrap}>
          <div onClick={() => setSelectedSupplierType(SupplierType.SUPPLIER_MANAGED)} className={clsx(classes.supplierTypeTile, selectedSupplierType === SupplierType.SUPPLIER_MANAGED && classes.selectedSupplierType)}>
            <SvgCarIcon />
            <span>Supplier Managed</span>
          </div>
          <div className={classes.recommendedLabel}>Recommended</div>
        </div>
        <div>OR</div>
        <div onClick={() => setSelectedSupplierType(SupplierType.SELF_MANAGED)} className={clsx(classes.supplierTypeTile, selectedSupplierType === SupplierType.SELF_MANAGED && classes.selectedSupplierType)}>
          <SvgShopIcon />
          <span>
            Self <br />
            Managed
          </span>
        </div>
      </div>
      <div className={classes.supplierTypeText}>
        At Open Pantry we offer you two ways to manage your products & pricing. You can select manage your pricing your self, or you can
        invite your suppliers to manage your products & prices themselves.
      </div>
      <CommonButton
        onClick={() => {
          push('/account/suppliers/add', { addForm: true });
        }}
        title='Next'
        disabled={selectedSupplierType ? false : true}
        width={215}
      />
    </div>
  );
};
